import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const IF = () => {
  const goToOperators = () => {
    const operatorsTable = document.getElementById("operators-table");
    if (operatorsTable) {
      operatorsTable.scrollIntoView({ behavior: "smooth" });
    } else {
      window.open("/#/manual?key=project.compute");
    }
  };

  return (
    <CardSection id="IF" title="IF">
      <Paragraph>
        주어진 조건이 참인지 거짓인지에 따라 지정한 값을 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>IF(CONDITION, TRUE_VALUE, FALSE_VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>CONDITION</b>은 평가하려는 표현식입니다.
          </Li>
          <Li>
            <b>TRUE_VALUE</b>는 <b>CONDITION</b>이 true인 경우 반환되는
            값입니다.
          </Li>
          <Li>
            <b>FALSE_VALUE</b>는 <b>CONDITION</b>이 false인 경우 반환되는
            값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>IF(`model` == "4 Series", "N/A", `model`)</Paragraph>
        <Img src="computeIf" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>IF</b> 함수는 다른 열의 값을 기반으로 새로운 열을 생성할 때
          유용합니다. <b>CONDITION</b>은 <b>TRUE</b> 또는 <b>FALSE</b> 값을
          제공해야 합니다.
        </Paragraph>
        <Paragraph>
          <b>CONDITION</b>의 일부로 다른 기능을 통합할 수 있습니다. 예를 들어 또
          다른 <b>IF</b> 함수를 값 중 하나로 사용할 수 있으며, 이를 통해 반환된
          값을 매우 세밀하게 제어합니다.
        </Paragraph>
        <Paragraph>
          대부분의 경우 <b>CONDITION</b>에는 연산자가 포함됩니다. 비교 연산자의
          경우 <a onClick={goToOperators}>Comparison Operators</a> 문서를
          참조하세요.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
